import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';
import {Order, PaginatedResult, PlaceOrder, Restaurant} from '../restaurant-manager.models';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(protected apiService: ApiService) {}

  place(order: PlaceOrder): Observable<Order> {
    return this
      .apiService.post<Order>('/orders', order, true)
      .pipe(map((result: any) => {
        return new Order(result);
      }));
  }

  assign(id: string): Observable<Order> {
    return this.apiService
      .post<Order>('/orders/' + id + '/assign', {}, true)
      .pipe(map(r => new Order(r)));
  }

  assigned(): Observable<Order[]> {
    return this.apiService
      .get<Order[]>('/orders/assigned', true)
      .pipe(map(r => r.map(o => new Order(o))));
  }

  print(ids: string[]): Observable<any> {
    return this.apiService.post<Order>('/orders/print', {orders: ids}, true);
  }

  changeOrderStatus(order: Order, status: string): Observable<Order> {
    return this
      .apiService
      .put<Order>('/orders/' + order.id + '/status', {status}, true)
      .pipe(map(r => new Order(r)));
  }

  findCurrentByRestaurant(restaurant: Restaurant, deliverySlot: string = null): Observable<Order[]> {
    return this
      .apiService
      .get<Order[]>('/orders/restaurant/' + restaurant.id + '/current?deliverySlot=' + deliverySlot, true)
      .pipe(map(orders => orders.map(o => new Order(o))));
  }

  getOrderById(id: string): Observable<Order> {
    return this
      .apiService.get<Order>('/orders/' + id, true)
      .pipe(map(result => new Order(result)));
  }

  getOrderByRef(ref: string): Observable<Order> {
    return this
      .apiService.get<Order>('/orders/ref/' + ref, true)
      .pipe(map(result => new Order(result)));
  }

  getOrdersByIds(restaurantId: string, ids: string[]): Observable<Order[]> {
    return this
      .apiService
      .get<Order[]>('/restaurants/' + restaurantId + '/orders?ids=' + ids.join(','), true)
      .pipe(map(orders => orders.map(o => new Order(o))));
  }

  getOrdersByRestaurant(restaurantId: string, date: string, page: number, perPage = 100, sessionDate: string = null): Observable<PaginatedResult<Order>> {
    let route = '/restaurants/' + restaurantId + '/orders?date=' + date + '&page=' + page + '&perPage=' + perPage;
    if (sessionDate) {
      route += '&sessionDate=' + sessionDate;
    }
    return this
      .apiService
      .get<PaginatedResult<Order>>(route, true)
      .pipe(map(p => new PaginatedResult<Order>(p, Order)));
  }

  list(): Observable<Order[]> {
    return this
      .apiService.get<Order[]>('/orders', true)
      .pipe(map(orders => orders.map(o => new Order(o))));
  }

  getNextSlotsOrders(restaurantId: string, statuses: string[]): Observable<number> {
    return this.apiService.get<number>('/restaurants/' + restaurantId + '/next-slot/orders?statuses=' + statuses.join(','), true);
  }

  getExportData(params: any): Observable<{ [key: string]: string }[]> {
    return this.apiService.get<{[key: string]: string}[]>('/exports/orders?params=' + btoa(JSON.stringify(params)), true);
  }

}
